import { render } from "./JobFullStackDeveloper.vue?vue&type=template&id=211a2d62&scoped=true"
import script from "./JobFullStackDeveloper.vue?vue&type=script&lang=js"
export * from "./JobFullStackDeveloper.vue?vue&type=script&lang=js"

import "./JobFullStackDeveloper.vue?vue&type=style&index=0&id=211a2d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a2d62"]])

export default __exports__